var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmex(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 22,
    viewBox: "0 0 32 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "amex-a49b82f46c5cd6a96a6e418a6ca1717c.svg",
    clipPath: "url(#clip0_999_897)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.0178 0.610107H3.04281C1.60825 0.610107 0.445312 1.77305 0.445312 3.20761V18.7926C0.445312 20.2272 1.60825 21.3901 3.04281 21.3901H29.0178C30.4524 21.3901 31.6153 20.2272 31.6153 18.7926V3.20761C31.6153 1.77305 30.4524 0.610107 29.0178 0.610107Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3203 18.0053V10.6006L31.4994 10.6124V12.6578L29.9762 14.2857L31.4994 15.9284V18.0172H29.0674L27.7749 16.591L26.4916 18.0226L18.3203 18.0053Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2031 17.1935V11.4155H24.1024V12.7466H20.7894V13.6501H24.0234V14.959H20.7894V15.8465H24.1024V17.1935H19.2031Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0782 17.1936L26.7892 14.3013L24.0781 11.4158H26.1764L27.833 13.2471L29.4942 11.4158H31.5023V11.4612L28.8491 14.3013L31.5023 17.1117V17.1936H29.474L27.7881 15.344L26.1195 17.1936H24.0782Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9347 4.02832H22.1115L23.2273 6.56199V4.02832H27.1493L27.8256 5.92653L28.5043 4.02832H31.4991V11.433H15.6719L18.9347 4.02832Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5364 4.83252L16.9727 10.6057H18.731L19.2147 9.44958H21.8355L22.3189 10.6057H24.121L21.5679 4.83252H19.5364ZM19.7567 8.15399L20.5256 6.31617L21.2939 8.15399H19.7567Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0977 10.6048V4.83179L26.5693 4.84028L27.8412 8.38942L29.1213 4.83179H31.5V10.6048L29.9693 10.6184V6.65285L28.5244 10.6048H27.1272L25.6523 6.6393V10.6048H24.0977Z",
    fill: "#016FD0"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_999_897"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.17,
    height: 20.78,
    fill: "white",
    transform: "translate(0.445312 0.610107)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/Amex.73fe56025c0691d704702e509fc91ab6.svg";
export { ForwardRef as ReactComponent };